import { render, staticRenderFns } from "./main_question.vue?vue&type=template&id=2efb62ae&scoped=true&"
import script from "./main_question.vue?vue&type=script&lang=js&"
export * from "./main_question.vue?vue&type=script&lang=js&"
import style0 from "./main_question.vue?vue&type=style&index=0&id=2efb62ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb62ae",
  null
  
)

export default component.exports